export const FieldGovernanceTypes = {
  List: 'list',
  Autonumber: 'autonumber',
  Autofill: 'autofill',
  Concatenation: 'concatenation',
  Constant: 'constant',
  Date: 'date',
  Text: 'text',
  Pattern: 'pattern',
  'Content Comprehension': 'creative',
} as const
